/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.14.0
 */

import styled from 'styled-components';

export const FormAddressStyled = styled.div.attrs({
    className: 'form-address-fields',
})`
    .form-address-fields__group {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 32px;
        margin-bottom: 24px;
    }

    .form-address-fields__house {
        display: flex;
        flex-direction: column;
    }
`;

export const FormAddressOpenIconStyled = styled.div`
    margin-left: 12px;
    cursor: pointer;

    &.disabled {
        cursor: auto;
        pointer-events: none;
    }
`;

export const FormAddressInfoBlockStyled = styled.div`
    padding: 0 56px;
    margin-bottom: 24px;
`;
